import { CellProps } from 'react-table'
import { PlainHeader, sortableColumn, StackedCell, StatusBadge, TableColumn } from 'app/components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { MedicamentoList } from '../../core/_models'
import { MedicamentosActionsCell } from './MedicamentosActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { ROTULO_RECEITUARIO } from 'app/modules/apps/atendimento_medicos/prescricao/core/receituario'

export const medicamentosColumns = (t: TFunction): ReadonlyArray<TableColumn<MedicamentoList>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Nome com a substância como apoio; os dois seguem ordenáveis.
  sortableColumn<MedicamentoList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.nome') },
      { field: 'substancia', label: t('cols.substancia') },
    ],
    Cell: ({ row }: CellProps<MedicamentoList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.substancia} />
    ),
  }),
  sortableColumn<MedicamentoList>({
    id: 'laboratorio',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'laboratorio', label: t('cols.laboratorio') }],
    Cell: ({ row }: CellProps<MedicamentoList>) => (
      <StackedCell primary={row.original.laboratorio} />
    ),
  }),
  // A tarja deixou de ser coluna no backend (deriva do receituário): ordenar/filtrar é pelo receituário.
  sortableColumn<MedicamentoList>({
    id: 'receituario',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'receituario', label: t('receituario.label') }],
    Cell: ({ row }: CellProps<MedicamentoList>) => (
      <StackedCell
        primary={row.original.receituario ? ROTULO_RECEITUARIO[row.original.receituario] : '-'}
        secondary={row.original.tarja}
      />
    ),
  }),
  sortableColumn<MedicamentoList>({
    id: 'ativo',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<MedicamentoList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<MedicamentoList>) => (
      <MedicamentosActionsCell medicamento={row.original} />
    ),
  },
]
